import './CompaniesSearchBar.css';
import { BsHouse } from "react-icons/bs";
import { GiFamilyHouse } from "react-icons/gi";
import { TbMap2 } from "react-icons/tb";
import { HiOutlineBuildingOffice } from "react-icons/hi2";
import SearchBarNavButtons from '../Header/SearchBarNavButtons/SearchBarNavButtons';
import { useAtom } from 'jotai';
import { useSearchedCompany, useAllCompanies } from '../../data/GlobalStates';


const CompaniesSearchBar = () => {

      const [ SearchedCompany, setSearchedCompany] = useAtom(useSearchedCompany);
      const [ AllCompanies, setAllCompanies] = useAtom(useAllCompanies);

      const setCompaniesInputValue = (e) => {
          if (e.target.value.length) {
            setSearchedCompany(AllCompanies.filter( company => company.name.toLowerCase().includes(e.target.value.toLowerCase())))
          } else if (!e.target.value.length) {
            setSearchedCompany(AllCompanies)
          }
      };

    return (
        <div id='SearchBarMainDiv'>
             <div id='SearchInputsAndLogosContainer'>
               <div className='FirmBaseSearchBarAndNavifation'>
                 <input id='CompaniesSearchInput' placeholder='Wyszukaj Firmy' onChange={setCompaniesInputValue}></input>
                 <SearchBarNavButtons />
               </div>
               <div className='SearchInputIconsContainer'>
                            <BsHouse className='searchInputIcons'/>
                            <GiFamilyHouse className='searchInputIcons'/>
                            <TbMap2 className='searchInputIcons'/>
                            <HiOutlineBuildingOffice className='searchInputIcons'/> 
              </div>
             </div>
        </div>
    )
}

export default CompaniesSearchBar;
